import { Title } from '@angular/platform-browser';
import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HostListener } from '@angular/core';

import { AuthDataService } from '@app/auth';
import { AuthQuery } from '@app/auth/auth.query';

import { environment } from './../../environments/environment';
import { Logger } from '@core';

import { JournalService, MailService, Mail } from '@core';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit {
  events: string[] = [];
  opened: boolean;
  appropriateClass: string = '';

  isEmptyNotification = true;

  //showExtendedVersion = environment.feature_ZAHLUNGSABGLEICH;
  showExtendedVersion = false;

  imageStorage = environment.serverUrl + '/'; // images gehen über api

  @HostListener('window:resize', ['$event'])
  getScreenHeight() {
    //console.log(window.innerHeight);
    if (window.innerHeight <= 412) {
      this.appropriateClass = 'bottomRelative';
    } else {
      this.appropriateClass = 'bottomStick';
    }
  }

  constructor(
    private router: Router,
    private titleService: Title,
    private authService: AuthDataService,
    public authQuery: AuthQuery,
    private journalService: JournalService
  ) {
    console.log('shell constructor - isLoggedIn:', this.authQuery.isLoggedIn);
    
    // Immediate check and redirect if not logged in
    if (!this.authQuery.isLoggedIn) {
      console.log('User not logged in in constructor, redirecting to login');
      this.router.navigate(['/login'], { replaceUrl: true });
    } else {
      // User is logged in - check if we're on a blank route and redirect to dashboard
      const currentUrl = this.router.url;
      console.log('Constructor - User is logged in, current URL:', currentUrl);
      
      if (currentUrl === '/' || currentUrl === '' || currentUrl === '/#') {
        console.log('Constructor - Blank route detected, redirecting to dashboard');
        this.router.navigate(['/dashboard'], { replaceUrl: true });
      }
    }
    
    //this.getScreenHeight();
  }

  ngOnInit() {
    console.log('shell loaded');
    
    // Check if user is not logged in and redirect to login
    if (!this.authQuery.isLoggedIn) {
      console.log('User not logged in, redirecting to login');
      this.router.navigate(['/login'], { replaceUrl: true });
    } else {
      // User is logged in - check if we're on a blank route and redirect to dashboard
      const currentUrl = this.router.url;
      console.log('User is logged in, current URL:', currentUrl);
      
      if (currentUrl === '/' || currentUrl === '' || currentUrl === '/#') {
        console.log('Blank route detected, redirecting to dashboard');
        this.router.navigate(['/dashboard'], { replaceUrl: true });
      }
    }
    
    // Additional safety check with timeout
    setTimeout(() => {
      if (!this.authQuery.isLoggedIn) {
        console.log('Safety check - User still not logged in, forcing redirect to login');
        this.router.navigate(['/login'], { replaceUrl: true });
      } else {
        // Safety check for logged in users on blank routes
        const currentUrl = this.router.url;
        if (currentUrl === '/' || currentUrl === '' || currentUrl === '/#') {
          console.log('Safety check - Blank route detected, redirecting to dashboard');
          this.router.navigate(['/dashboard'], { replaceUrl: true });
        }
      }
    }, 100);
  }

  logout() {
    this.authService.logout().subscribe(() => {
      //this.router.navigate(['/login'], { replaceUrl: true });
      // changes mario: 25.3.24
      //probably better: this.router.navigateByUrl('/login');

      // Alternatively, for a hard reset, you might want to reload the entire application
      window.location.href = '/login';
    });
    console.log('logout');
    this.journalService.log('Abmeldung Logout erfolgreich', '', '');
  }

  get role(): number | null {
    return this.authQuery.role;
  }

  get username(): string | null {
    return this.authQuery.name;
  }

  get profile_image(): string | null {
    return this.authQuery.profile_image;
  }

  get profileImageSrc(): string {
    const profileImage = this.authQuery.profile_image;
    // Check if profile image exists and is not empty
    if (profileImage && profileImage.trim() !== '' && profileImage !== 'null' && profileImage !== 'undefined') {
      return this.imageStorage + profileImage;
    }
    // Return a default avatar image
    return 'assets/images/default-avatar.svg';
  }

  get userInitials(): string {
    const name = this.authQuery.name;
    if (name && name.trim() !== '') {
      const names = name.trim().split(' ');
      if (names.length >= 2) {
        return (names[0][0] + names[names.length - 1][0]).toUpperCase();
      } else if (names.length === 1) {
        return names[0][0].toUpperCase();
      }
    }
    return 'U'; // Default initial for User
  }

  onImageError(event: any): void {
    // Set the default avatar when image fails to load
    event.target.src = 'assets/images/default-avatar.svg';
  }

  get email(): string | null {
    return this.authQuery.email;
  }

  get werbungActive(): boolean | false {
    return false;
  }

  /* handle dropdown by click */
  isDropdownOpen = false;
  @ViewChild('dropdownMenu') dropdownMenu!: ElementRef;
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  /**--- */

  onSideNavOpened() {
    //  do something
  }

  get isMobile(): boolean {
    //return this.media.isActive('xs') || this.media.isActive('sm');
    return false;
  }

  get title(): string {
    return this.titleService.getTitle();
  }

  get isSuperUser(): boolean {
    // Check if current user is superuser (role 1)
    return this.role === 1;
  }

  get isCompAdmin(): boolean {
    // Check if current user is compAdmin (role 2)
    return this.role === 2;
  }

  get isBüro(): boolean {
    // Check if current user is büro (assuming role 3, adjust as needed)
    return this.role === 3;
  }

  get canSeeDashboard(): boolean {
    // Dashboard visible for Administrator (role 1) and compAdmin (role 2)
    return this.role === 1 || this.role === 2;
  }

  get canSeeSettings(): boolean {
    // Settings visible only for compAdmin (role 2) and Administrator (role 1)
    return this.role === 1 || this.role === 2;
  }
}
